import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Tabs from '../../components/shared/Tabs';
import Header from './Components/Header';
import DataLink from './Components/DataLink';
import Transaction from './Components/Transaction';

interface NavBar {
    id: number;
    icon: string;
    name: string;
    component: JSX.Element;
}

const DataLinkAndTransaction = () => {
    const location = useLocation(),
        history = useHistory();
    const tabs: Array<NavBar> = [
        {
            id: 10,
            icon: '',
            name: 'Data Link',
            component: <DataLink />,
        },
        {
            id: 20,
            icon: '',
            name: 'Transaction',
            component: <Transaction />,
        },
    ];
    const [act, setAct] = useState<boolean>(location.hash.replace('#', '') === '20' ? true : false);
    const [activTab, setActivTab] = useState<string>(location.hash ? location.hash.replace('#', '') : '10');

    const tabSelected = (value: any) => {
        history.push({ hash: value });
    };

    useEffect(() => {
        setActivTab(history.location.hash ? history.location.hash.replace('#', '') : '10');
        switch (history.location.hash.replace('#', '')) {
            case '10':
                setAct(false);
                break;
            case '20':
                setAct(true);
                break;
            default:
                setAct(false);
                break;
        }
    }, [history.location.hash]);

    const checkTopDisplay = () => {
        switch (history.location.hash) {
            case '#20':
                return (
                    <Header
                        title="Transaction Management"
                        subtitle="We research commercial real estate, measure capital performance, market deals and enable you to acquire property securely"
                    />
                );

            default:
                return (
                    <Header
                        title="Data Link"
                        subtitle="To meet our clients’ most demanding business use cases, we work with best-in-class data experts to unlock unparalleled insight and value"
                    />
                );
        }
    };

    return (
        <div className="main-container">
            <div className="data-link-transaction-page">
                {checkTopDisplay()}
                <div className="data-link-transaction-page__navigation">
                    <Tabs
                        tabs={tabs}
                        onTabSelected={tabSelected}
                        defaultActiveKey={act ? '20' : '10'}
                        key={activTab}
                        className="data-link-transaction-page__navigation-content"
                    />
                </div>
            </div>
        </div>
    );
};
export default DataLinkAndTransaction;
